import moment from "moment";

export const authData = [
    {
        title: `BUSINESS PLAN 2024 TIMELINE`,
        value: '/bp/time',
        key: '/bp/time',
        children: [{
            title: '查看',
            key: 'read_time',
        }, {
            title: '编辑',
            key: 'edit_time',
        }]
    },
    {
        title: `Business Plan ${moment().add(1, 'y').format('YYYY')} Review Meeting Schedule`,
        value: '/bp/meeting',
        key: '/bp/meeting',
        children: [{
            title: '查看',
            key: 'read_meeting',
        }, {
            title: '编辑',
            key: 'edit_meeting',
        }]
    }, {
        title: `Hotel Information <br />酒店信息`,
        value: '/bp/cover',
        key: '/bp/cover',
        children: [{
            title: '查看',
            key: 'read_cover',
        }, {
            title: '编辑',
            key: 'edit_cover',
        }]
    }, {
        title: `Corporate Office Target <br />集团指标`,
        value: '/bp/target',
        key: '/bp/target',
        children: [{
            title: '查看',
            key: 'read_target',
        }, {
            title: '编辑',
            key: 'edit_target',
        }]
    }, {
        title: `Corporate Office Strategic Target<br/> 集团三年战略规划`,
        value: '/bp/strategic',
        key: '/bp/strategic',
        children: [{
            title: '查看',
            key: 'read_strategic',
        }, {
            title: '编辑',
            key: 'edit_strategic',
        }]
    }, {
        title: `财务总监阐述`,
        value: '/bp/elaborate_DOF',
        key: '/bp/elaborate_DOF',
        children: [{
            title: '查看',
            key: 'read_elaborate_DOF',
        }, {
            title: '编辑',
            key: 'edit_elaborate_DOF',
        }]
    }, {
        title: `销售总监阐述`,
        value: '/bp/elaborate_DOSM',
        key: '/bp/elaborate_DOSM',
        children: [{
            title: '查看',
            key: 'read_elaborate_DOSM',
        }, {
            title: '编辑',
            key: 'edit_elaborate_DOSM',
        }]
    }, {
        title: '1.0 DATA INPUT <br/> 数据导入',
        value: '/bp/1',
        key: '/bp/1',
        children: [{
            title: `1.1 DATA INPUT ${Number(moment().format('YYYY')) - 1} and ${moment().format('YYYY')} 数据输入 ${Number(moment().format('YYYY')) - 1} and ${moment().format('YYYY')}`,
            value: '/bp/1_1',
            key: '/bp/1_1',
            children: [{
                title: '查看',
                key: 'read_1_1',
            }, {
                title: '编辑',
                key: 'edit_1_1',
            }]
        }, {
            title: `1.2 DATA INPUT ${moment().add(1, 'y').format('YYYY')} 数据输入 ${moment().add(1, 'y').format('YYYY')}`,
            value: '/bp/1_2',
            key: '/bp/1_2',
            children: [{
                title: '查看',
                key: 'read_1_2',
            }, {
                title: '编辑',
                key: 'edit_1_2',
            }]
        }]
    }, {
        title: `2.0 Executive Summary <br />经营综合报告`,
        value: '/bp/2',
        key: '/bp/2',
        children: [{
            title: '查看',
            key: 'read_2',
        }, {
            title: '编辑',
            key: 'edit_2',
        }]
    }, {
        title: '3.0 Market Planning<br/> 市场计划',
        value: '/bp/3',
        key: '/bp/3',
        children: [{
            title: `3.1 External Factors and Possible Impacts 外部因素及可能带来的影响`,
            value: '/bp/3_1',
            key: '/bp/3_1',
            children: [{
                title: '查看',
                key: 'read_3_1',
            }, {
                title: '编辑',
                key: 'edit_3_1',
            }]
        }, {
            title: `3.2 Internal Factors 内部因素`,
            value: '/bp/3_2',
            key: '/bp/3_2',
            children: [{
                title: '查看',
                key: 'read_3_2',
            }, {
                title: '编辑',
                key: 'edit_3_2',
            }]
        }]
    }, {
        title: `4.0 Internal Analysis (SWOT)<br /> 内部 (S 优势 W 劣势 O 机会 T 威胁 分析`,
        value: '/bp/4',
        key: '/bp/4',
        children: [{
            title: '查看',
            key: 'read_4',
        }, {
            title: '编辑',
            key: 'edit_4',
        }]
    }, {
        title: '5.0 Competitive Landscape<br/> 竞争势态',
        value: '/bp/5',
        key: '/bp/5',
        children: [{
            title: `5.1 Competitive Information 竞争对手信息`,
            value: '/bp/5_1',
            key: '/bp/5_1',
            children: [{
                title: '查看',
                key: 'read_5_1',
            }, {
                title: '编辑',
                key: 'edit_5_1',
            }]
        },
        {
            title: `5.2 Competitive SWOT Analysis 竞争对手SWOT分析`,
            value: '/bp/5_2',
            key: '/bp/5_2',
            children: [{
                title: '查看',
                key: 'read_5_2',
            }, {
                title: '编辑',
                key: 'edit_5_2',
            }]
        }, {
            title: `5.3 KPI Trend Analysis 关键绩效指数趋势分析`,
            value: '/bp/5_3',
            key: '/bp/5_3',
            children: [{
                title: '查看',
                key: 'read_5_3',
            }, {
                title: '编辑',
                key: 'edit_5_3',
            }]
        }]
    }, {
        title: '6.0 Rates<br/> 价格体系',
        value: '/bp/6_all',
        key: '/bp/6_all',
        children: [{
            title: `6.1 Rate Structure 价格体系模板`,
            value: '/bp/7',
            key: '/bp/7',
            children: [{
                title: '查看',
                key: 'read_7',
            }, {
                title: '编辑',
                key: 'edit_7',
            }]
        }]
    }, {
        title: `7.0 Rooms Statistic<br /> 客房统计`,
        value: '/bp/7_1',
        key: '/bp/7_1',
        children: [{
            title: '查看',
            key: 'read_7_1',
        }, {
            title: '编辑',
            key: 'edit_7_1',
        }]
    }, {
        title: '8.0 Room Revenue Budget <br/>客房收益预算',
        value: '/bp/8_all',
        key: '/bp/8_all',
        children: [{
            title: `8.1 Definitions of Key Market Segments 主要细分市场的定义`,
            value: '/bp/8_4',
            key: '/bp/8_4',
            children: [{
                title: '查看',
                key: 'read_8_4',
            }, {
                title: '编辑',
                key: 'edit_8_4',
            }]
        }, {
            title: `8.2 Budget By Market Segment 市场细分预算`,
            value: '/bp/8',
            key: '/bp/8',
            children: [{
                title: '查看',
                key: 'read_8',
            }, {
                title: '编辑',
                key: 'edit_8',
            }]
        },
        // {
        //     title: `8.2 Three Years Market Segment 三年市场细分`,
        //     value: '/bp/8_1',
        //     key: '/bp/8_1',
        //     children: [{
        //         title: '查看',
        //         key: 'read_8_1',
        //     }, {
        //         title: '编辑',
        //         key: 'edit_8_1',
        //     }]
        // },
        {
            title: `8.3 Market Segment Strategy 细分市场战略`,
            value: '/bp/8_3',
            key: '/bp/8_3',
            children: [{
                title: '查看',
                key: 'read_8_3',
            }, {
                title: '编辑',
                key: 'edit_8_3',
            }]
        }]
    }, {
        title: '8.0 new',
        value: '/bp/8_new',
        key: '/bp/8_new',
        children: [{
            title: `8.1 Definitions of Key Market Segments 主要细分市场的定义`,
            value: '/bp/8_4',
            key: '/bp/8_4',
            children: [{
                title: '查看',
                key: 'read_8_4',
            }, {
                title: '编辑',
                key: 'edit_8_4',
            }]
        }, {
            title: '8.2',
            value: '/bp/8_2new',
            key: '/bp/8_2new',
            children: [{
                title: '8.2.1 Budget By Market Segment 市场细分预算',
                value: '/bp/8new_2_1',
                key: '/bp/8new_2_1',
                children: [{
                    title: '查看',
                    key: 'read_8new_2_1',
                }, {
                    title: '编辑',
                    key: 'edit_8new_2_1',
                }]
            }, {
                title: '8.2.2 Yearly Budget By Market Segment 年度预算市场细分数据分析 ',
                value: '/bp/8new_2_2',
                key: '/bp/8new_2_2',
                children: [{
                    title: '查看',
                    key: 'read_8new_2_2',
                }, {
                    title: '编辑',
                    key: 'edit_8new_2_2',
                }]
            }, {
                title: `8.2.3 Budget Summary`,
                value: '/bp/8_0_budget',
                key: '/bp/8_0_budget',
                children: [{
                    title: '查看',
                    key: 'read_8_0_budget',
                }, {
                    title: '编辑',
                    key: 'edit_8_0_budget',
                }]
            }]
        }, {
            title: '8.3',
            value: '/bp/8_3new',
            key: '/bp/8_3new',
            children: [{
                title: '8.3.1 Market Segment Strategy 细分市场战略',
                value: '/bp/8new_3_1',
                key: '/bp/8new_3_1',
                children: [{
                    title: '查看',
                    key: 'read_8new_3_1',
                }, {
                    title: '编辑',
                    key: 'edit_8new_3_1',
                }]
            }]
        }]
    }, {
        title: '9.0 Account Management<br /> 客户管理',
        value: '/bp/9_3',
        key: '/bp/9_3',
        children: [{
            title: '查看',
            key: 'read_9_3',
        }, {
            title: '编辑',
            key: 'edit_9_3',
        }]
    },
    // {
    //     title: `10.0 Budget by Top Accounts 关键客户预算分析`,
    //     value: '/bp/10',
    //     key: '/bp/10',
    //     children: [{
    //         title: '查看',
    //         key: 'read_10',
    //     }, {
    //         title: '编辑',
    //         key: 'edit_10',
    //     }]
    // },
    {
        title: '11.0 Marketing Communications <br/>公关营销',
        value: '/bp/11',
        key: '/bp/11',
        children: [{
            title: `11.1 Hotel Key Action Plan by Category 酒店主要行动计划分类`,
            value: '/bp/14',
            key: '/bp/14',
            children: [{
                title: '查看',
                key: 'read_14',
            }, {
                title: '编辑',
                key: 'edit_14',
            }]
        }, {
            title: `11.2 Advertising & Business Promotion 广告及促销推广计划`,
            value: '/bp/11_2',
            key: '/bp/11_2',
            children: [{
                title: '查看',
                key: 'read_11_2',
            }, {
                title: '编辑',
                key: 'edit_11_2',
            }]
        }, {
            title: `11.3 Media Planning 媒体计划`,
            value: '/bp/11_3',
            key: '/bp/11_3',
            children: [{
                title: '查看',
                key: 'read_11_3',
            }, {
                title: '编辑',
                key: 'edit_11_3',
            }]
        }, {
            title: `11.4 Hotel Event Summary 酒店活动概览`,
            value: '/bp/11_4',
            key: '/bp/11_4',
            children: [{
                title: '查看',
                key: 'read_11_4',
            }, {
                title: '编辑',
                key: 'edit_11_4',
            }]
        }]
    }, {
        title: '12.0 F&B Budget<br/> 餐饮预算',
        value: '/bp/12_all',
        key: '/bp/12_all',
        children: [{
            title: `12.0 Food & Beverage Revenue Analysis 餐饮收益分析`,
            value: '/bp/12',
            key: '/bp/12',
            children: [{
                title: '查看',
                key: 'read_12',
            }, {
                title: '编辑',
                key: 'edit_12',
            }]
        }, {
            title: `12.1 Food & Beverage Profit Analysis 餐饮部盈利分析`,
            value: '/bp/12_1',
            key: '/bp/12_1',
            children: [{
                title: '查看',
                key: 'read_12_1',
            }, {
                title: '编辑',
                key: 'edit_12_1',
            }]
        }, {
            title: `12.2 F&B by outlet by month`,
            value: '/bp/table12_12_2',
            key: '/bp/table12_12_2',
            children: [{
                title: '查看',
                key: 'read_table12_12_2',
            }, {
                title: '编辑',
                key: 'edit_table12_12_2',
            }]
        }]
    }, {
        title: '13.0 Catering Analysis <br/>宴会预算',
        value: '/bp/12_2_all',
        key: '/bp/12_2_all',
        children: [{
            title: `13.0 Total Catering/Banquet 宴会`,
            value: '/bp/12_2',
            key: '/bp/12_2',
            children: [{
                title: '查看',
                key: 'read_12_2',
            }, {
                title: '编辑',
                key: 'edit_12_2',
            }]
        }, {
            title: `13.1 Local Catering 本地宴会`,
            value: '/bp/12_2_1',
            key: '/bp/12_2_1',
            children: [{
                title: '查看',
                key: 'read_12_2_1',
            }, {
                title: '编辑',
                key: 'edit_12_2_1',
            }]
        }, {
            title: `13.2 Group & Conventions 团队&会议团`,
            value: '/bp/12_2_2',
            key: '/bp/12_2_2',
            children: [{
                title: '查看',
                key: 'read_12_2_2',
            }, {
                title: '编辑',
                key: 'edit_12_2_2',
            }]
        }, {
            title: `13.3 Catering and Events (C&E) Segmentation 宴会及活动市场细分定义`,
            value: '/bp/12_2_3',
            key: '/bp/12_2_3',
            children: [{
                title: '查看',
                key: 'read_12_2_3',
            }, {
                title: '编辑',
                key: 'edit_12_2_3',
            }]
        }, {
            title: `13.4 Yearly Catering and Events (C&E) Analysis年度宴会及活动分析`,
            value: '/bp/13_4',
            key: '/bp/13_4',
            children: [{
                title: '查看',
                key: 'read_13_4',
            }, {
                title: '编辑',
                key: 'edit_13_4',
            }]
        }]
    }, {
        title: `14.0 Manning Budget<br /> 员工编制预算明细表`,
        value: '/bp/19',
        key: '/bp/19',
        children: [{
            title: '查看',
            key: 'read_19',
        }, {
            title: '编辑',
            key: 'edit_19',
        }]
    }, {
        title: `15.0 Manning Level Report<br /> 人员流动报告`,
        value: '/bp/19_1',
        key: '/bp/19_1',
        children: [{
            title: '查看',
            key: 'read_19_1',
        }, {
            title: '编辑',
            key: 'edit_19_1',
        }]
    }, {
        title: '16.0 Labor Cost Management<br/> 人力成本管理',
        value: '/bp/20_all',
        key: '/bp/20_all',
        children: [{
            title: `16.1 Labor Cost by Levels and Departments 按照级别和部门划分的人员成本`,
            value: '/bp/20',
            key: '/bp/20',
            children: [{
                title: '查看',
                key: 'read_20',
            }, {
                title: '编辑',
                key: 'edit_20',
            }]
        }, {
            title: `16.2 Labor Cost Management Action Plans 人力成本管理行动计划`,
            value: '/bp/20_1',
            key: '/bp/20_1',
            children: [{
                title: '查看',
                key: 'read_20_1',
            }, {
                title: '编辑',
                key: 'edit_20_1',
            }]
        }, {
            title: `16.3 Casual labor and HR Departmental Expenses 临时帮工和外包及人力资源部费用`,
            value: '/bp/20_2',
            key: '/bp/20_2',
            children: [{
                title: '查看',
                key: 'read_20_2',
            }, {
                title: '编辑',
                key: 'edit_20_2',
            }]
        }]
    }, {
        title: '17.0 ENG Report<br/> 工程部门报告',
        value: '/bp/17_all',
        key: '/bp/17_all',
        children: [{
            title: `17.1 Rooms, F&B and Conference Feature Infomation 客房、餐饮及宴会设施情况`,
            value: '/bp/17_1',
            key: '/bp/17_1',
            children: [{
                title: '查看',
                key: 'read_17_1',
            }, {
                title: '编辑',
                key: 'edit_17_1',
            }]
        }, {
            title: `17.2 Utility Cost Trend Report 能源成本表`,
            value: '/bp/17_2',
            key: '/bp/17_2',
            children: [{
                title: '查看',
                key: 'read_17_2',
            }, {
                title: '编辑',
                key: 'edit_17_2',
            }]
        }, {
            title: `17.3 Utility Cost Trend Analysis 能源成本趋势分析`,
            value: '/bp/17_3',
            key: '/bp/17_3',
            children: [{
                title: '查看',
                key: 'read_17_3',
            }, {
                title: '编辑',
                key: 'edit_17_3',
            }]
        }, {
            title: `17.4 Maintenance Expenses 维修费用`,
            value: '/bp/17_4',
            key: '/bp/17_4',
            children: [{
                title: '查看',
                key: 'read_17_4',
            }, {
                title: '编辑',
                key: 'edit_17_4',
            }]
        }]
    }, {
        title: `18.0 Profit and Loss Summary <br />利润表汇总`,
        value: '/bp/22',
        key: '/bp/22',
        children: [{
            title: '查看',
            key: 'read_22',
        }, {
            title: '编辑',
            key: 'edit_22',
        }]
    }, {
        title: `19.0 Breakeven Point Analysis<br /> 盈亏平衡点分析`,
        value: '/bp/23',
        key: '/bp/23',
        children: [{
            title: '查看',
            key: 'read_23',
        }, {
            title: '编辑',
            key: 'edit_23',
        }]
    }, {
        title: `20.0 Flow Thru Analysis <br />边际利润分析`,
        value: '/bp/24',
        key: '/bp/24',
        children: [{
            title: '查看',
            key: 'read_24',
        }, {
            title: '编辑',
            key: 'edit_24',
        }]
    }, {
        title: `21.0 Financial Model<br /> 财务分析模型`,
        value: '/bp/26',
        key: '/bp/26',
        children: [{
            title: '查看',
            key: 'read_26',
        }, {
            title: '编辑',
            key: 'edit_26',
        }]
    }, {
        title: '22.0 CAPEX Plan<br/> 资本支出计划',
        value: '/bp/30_all',
        key: '/bp/30_all',
        children: [{
            title: `22.1 Capital Expenditure Plan - Summary  资本支出计划 - 汇总表`,
            value: '/bp/30',
            key: '/bp/30',
            children: [{
                title: '查看',
                key: 'read_30',
            }, {
                title: '编辑',
                key: 'edit_30',
            }]
        }, {
            title: `22.2 Capital Expenditure Plan - Detail List 资本支出计划 － 明细表`,
            value: '/bp/30_1',
            key: '/bp/30_1',
            children: [{
                title: '查看',
                key: 'read_30_1',
            }, {
                title: '编辑',
                key: 'edit_30_1',
            }]
        }]
    }, {
        title: `23.0 2020 Forecast Updates 2020年预测更新`,
        value: '/bp/forecastupdate',
        key: '/bp/forecastupdate',
        children: [{
            title: '查看',
            key: 'read_forecastupdate',
        }, {
            title: '编辑',
            key: 'edit_forecastupdate',
        }]
    }, {
        title: `Business Plan 已添加PDF列表`,
        value: '/bp/pdf',
        key: '/bp/pdf',
        children: [{
            title: '查看',
            key: 'read_pdf',
        }, {
            title: '编辑',
            key: 'edit_pdf',
        }]
    }, {
        title: 'Executive Summary Report 月度经营报告',
        value: '/table',
        key: '/table',
        children: [{
            title: '查看',
            key: 'read_table',
        }, {
            title: '编辑',
            key: 'edit_table',
        }]
    }, {
        title: 'Human Resources 人力资源报告',
        value: '/hr',
        key: '/hr',
        children: [{
            title: '查看',
            key: 'read_hr',
        }, {
            title: '编辑',
            key: 'edit_hr',
        }]
    }]


export default authData;


// WEBPACK FOOTER //
// ./src/bp-views/user/data.js